module.exports = __webpack_public_path__ + "static/media/021.e8518761.webp";